(function ($) {

    ko.observableArray.fn.pushAll = function (valuesToPush) {
        var underlyingArray = this();
        this.valueWillMutate();
        ko.utils.arrayPushAll(underlyingArray, valuesToPush);
        this.valueHasMutated();
        return this;
    };

    ko.bindingHandlers.currency = {
        update: function (element, valueAccessor) {
            var val = ko.unwrap(valueAccessor()),
                currency,
                html;
            if (val === 0) {
                html = '<span class="currency-span" title="$0.00">$0.00</span>';
            } else {
                currency = $.cdh.helper.parseCurrency(val);

                html = '$' + currency.beforeDot + '.' + currency.afterDot;
                if (currency.negative) {
                    html = "(" + html + ")";
                }
                html = `<span class="currency-span" title=${html}>` + html + '</span>';
            }
            $(element).html(html);
        }
    };

    ko.bindingHandlers.editableText = {
        init: function (element, valueAccessor) {
            function onInput() {
                const observable = valueAccessor();
                observable($(this).text());
            }

            $(element).on('blur', onInput);
        },
        update: function (element, valueAccessor) {
            const value = ko.utils.unwrapObservable(valueAccessor());
            $(element).text(value);
        }
    };

    ko.bindingHandlers.currencyText = {
        update: function (element, valueAccessor) {
            var val = ko.unwrap(valueAccessor());
            var currency = $.cdh.helper.parseCurrency(val);

            var val = '$' + currency.beforeDot + '.' + currency.afterDot;
            if (currency.negative) {
                val = "(" + val + ")";
            }

            $(element).text(val);
        }
    };
    ko.bindingHandlers.phone = {
        update: function (element, valueAccessor) {
            var phone = ko.utils.unwrapObservable(valueAccessor());
            var formatPhone = function () {
                return phone.replace(/(\d{1})(\d{3})(\d{3})(\d{3})/, "+$1 $2 $3 $4");
            }
            ko.bindingHandlers.text.update(element, formatPhone);
        }
    };

    ko.bindingHandlers.currencySpans = {
        update: function (element, valueAccessor) {
            var val = ko.unwrap(valueAccessor());
            if (!val.isInterval || !val.SpendingLimitField) {
                var currency = $.cdh.helper.parseCurrency(val);
                var html = '$' + currency.beforeDot + '.' + currency.afterDot;
                if (currency.negative) {
                    html = "(" + html + ")";
                }
                html = `<span class="currency-span" title=${html}>` + html + '</span>';
            }
            else {
                if (val.AccountPlanYear !== $.cdh.enums.planYear.future) {
                    var currency = $.cdh.helper.parseCurrency(val.balance());
                    var html = '$' + currency.beforeDot + '.' + currency.afterDot;
                    if (currency.negative) {
                        html = "(" + html + ")";
                    }
                    if (val.balance() != null) {
                        html = "<div><h4>" + val.SpendingLimitField.Title + `</h4></div><span class='currency-span' title=${html}>` + html + "</span >";
                    } else {
                        html = '';
                    }
                }
                else
                    html = "<div><h4>" + val.SpendingLimitField.Title + "</h4></div><span class='currency-span' title='$--.--'>$--.--</span >";
                
            }

            $(element).html(html);
        }
    };

    ko.bindingHandlers.masktrim = {
        init: function (element, valueAccessor) {
        },
        update: function (el, valueAccessor) {
            var val = ko.unwrap(valueAccessor());
            if (val.length > 4) {
                val = '*****' + val.slice(val.length - 4, val.length);
            }
            ko.utils.setTextContent(el, val);
        }
    };

    ko.bindingHandlers.masktrim12 = {
        init: function (element, valueAccessor) {
        },
        update: function (el, valueAccessor) {
            var val = ko.unwrap(valueAccessor());
            switch (val.length) {
                case 1:
                    val = '***********' + val;
                    break;
                case 2:
                    val = '**********' + val;
                    break;
                case 3:
                    val = '*********' + val;
                    break;
                default:
                    val = '********' + val.slice(val.length - 4, val.length);
                    break;
            }
            ko.utils.setTextContent(el, val);
        }
    };

    ko.virtualElements.allowedBindings.masktrim = true;

    ko.bindingHandlers.mask = {
        count: 4,
        init: function (element, valueAccessor) {
        },
        update: function (element, valueAccessor) {
            var value = ko.unwrap(valueAccessor());
            if ($.type(value) === 'string') {
                var tomask = value.length - ko.bindingHandlers.mask.count;
                if (tomask > 0) {
                    var m = ''; var count = tomask;
                    while (--count >= 0) m += '*';
                    value = m + value.substring(tomask);
                }
            } else {
                // not implemented yet way to customize mask logic
            }

            ko.utils.setTextContent(element, value);
        }
    };
    ko.virtualElements.allowedBindings.mask = true;

    ko.bindingHandlers.maskAccountRoutingNumber = {
        length: 8,
        init: function (element, valueAccessor) {

        },
        update: function (element, valueAccessor) {
            var value = ko.unwrap(valueAccessor());
            if ($.type(value) === 'string') {
                var tomask = ko.bindingHandlers.maskAccountRoutingNumber.length - value.length;
                if (tomask > 0) {
                    var m = ''; var count = tomask;
                    while (--count >= 0) m += '*';
                    value = m + value;
                }
            }
            ko.utils.setTextContent(element, value);
        }
    }
    function bindFiles(fileList, observableArray, onlyOne, onlyOneMessage, acceptMimes, fixedSizeMb, totalFixedSizeMb, invalidFileFormatMessage, onLoadCallback) {
        if (!fileList || fileList.length == 0)
            return;

        var maxFileSizeMb = $.cdh.const.maxUploadSizeMb;
        if (fixedSizeMb) {
            maxFileSizeMb = fixedSizeMb;
        }

        var maxTotalFileSizeMb = 128;
        if (totalFixedSizeMb) {
            maxTotalFileSizeMb = totalFixedSizeMb;
        }

        maxTotalFileSizeMb = maxTotalFileSizeMb.toFixed(1);

        var totalFileSize = 0;
        var files = observableArray();
        if (files) {
            for (var i = 0; i < files.length; ++i) {
                totalFileSize += files[i].fileSize;
            }
        }
        var totalLimitReached = false;
        $.each(fileList, function (i, file) {
            var reader = new FileReader();
            reader.onload = function (e) {

                var uploadFile = function () {
                    if (totalLimitReached) return;
                    var fileModel = new $.cdh.models.fileModel(e.target.result, file.name, file.size);

                    if (acceptMimes != null && fileModel.contentType.search(acceptMimes) != 0) {
                        if (!fileModel.base64) {
                            alert($.cdh.languageConstant.getConstant('extension-validation.zero-file-size'));
                            return;
                        }
                        if (invalidFileFormatMessage) {
                            alert(invalidFileFormatMessage);
                            if (onLoadCallback) {
                                onLoadCallback();
                            }
                        } else {
                            if (onLoadCallback) {
                                onLoadCallback();
                            }
                            alert($.cdh.languageConstant.getConstant('extension-validation.file-type-supported'));
                        }
                        return;
                    }

                    var fileSize = file.size;

                    var errorMessage = null;
                    if (fileSize > maxFileSizeMb * 1024 * 1024) {
                        errorMessage = $.cdh.languageConstant.getConstant('extension-validation.file-size-limit', { '0': maxFileSizeMb });
                    } else if (totalFileSize + fileSize > maxTotalFileSizeMb * 1024 * 1024) {
                        errorMessage = $.cdh.languageConstant.getConstant('extension-validation.total-file-size', { '0': maxTotalFileSizeMb });
                    }

                    if (errorMessage) {
                        alert(errorMessage);
                        totalLimitReached = true
                        if (onLoadCallback) {
                            onLoadCallback();
                        }
                        return;
                    }

                    observableArray.push(fileModel);

                    totalFileSize += fileSize;

                    if (onLoadCallback) {
                        onLoadCallback();
                    }
                }

                if (onlyOne) {
                    if (observableArray().length > 0) {
                        if (onlyOneMessage) {
                            var okCallback = function () {
                                observableArray([]);
                                uploadFile();
                            };

                            var cancellCallback = function () {
                                if (onLoadCallback) {
                                    onLoadCallback();
                                }
                            };

                            $.cdh.helper.confirm(onlyOneMessage, okCallback, cancellCallback);
                        } else {
                            observableArray([]);
                            uploadFile();
                        }
                    } else {
                        uploadFile();
                    }
                } else {
                    uploadFile();
                }
            };

            reader.readAsDataURL(file);
        });
    }

    ko.bindingHandlers.file = {
        init: function (element, valueAccessor) {

            var options = valueAccessor();
            var onlyOne = options.onlyOne;
            var onlyOneMessage = options.onlyOneMessage;
            var fixedSizeMb = options.fixedSizeMb;
            var totalFixedSizeMb = options.totalFixedSizeMb;
            var items = options.items;
            var invalidFileFormatMessage = options.invalidFileFormatMessage;

            if (onlyOne) {
                $(element).removeAttr("multiple");
            }

            var input = $(element).is('input:file') ? $(element) : $(element).find('input:file');
            var acceptMimes = null;
            if (input.length > 0) {
                var accept = $(input[0]).attr('accept').replace(/ /g, '');
                if (accept) {
                    var mimes = accept.split(',');
                    $.each(mimes, function (i) { return mimes[i] = $.trim(mimes[i]); });
                    acceptMimes = RegExp(mimes.join('|'));
                }
            }

            ko.utils.registerEventHandler(element, 'change', function () {
                bindFiles(this.files, items, onlyOne, onlyOneMessage, acceptMimes, fixedSizeMb, totalFixedSizeMb, invalidFileFormatMessage, function () {
                    var control = $(element);
                    control.wrap('<form>').closest('form').get(0).reset();
                    control.unwrap();
                    var updateHeight = updateContainerHeight(control);
                    updateHeight();
                });
            });

            ko.utils.registerEventHandler(element, 'dragenter', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.originalEvent.dataTransfer.dropEffect = "copy";
            });

            ko.utils.registerEventHandler(element, 'dragover', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.originalEvent.dataTransfer.dropEffect = "copy";
            });

            ko.utils.registerEventHandler(element, 'drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
                bindFiles(e.originalEvent.dataTransfer.files, items, onlyOne, onlyOneMessage, acceptMimes, fixedSizeMb, totalFixedSizeMb, invalidFileFormatMessage, function () {
                    var updateHeight = updateContainerHeight($(element));
                    updateHeight();
                });
            });
        }
    }

    ko.bindingHandlers.printer = {

        init: function (element, valueAccessor) {
            var selector = ko.unwrap(valueAccessor());
            $(element).on("click", function (e) {
                $(element).closest(selector).printArea();
                e.stopImmediatePropagation();
                return false;
            });
        }
    };

    ko.bindingHandlers.numberInput = {
        init: function (element) {
            var $element = $(element);
            $element.keydown(function (e) {
                var maxLength = $(this).attr('maxlength');
                var ctrlKey = e.ctrlKey || e.metaKey;
                if (
                    // Allow: backspace, delete, tab, escape, enter, end,  home, left, right, F5,
                    $.inArray(e.keyCode, [46, 8, 9, 27, 13, 35, 36, 37, 39, 116]) !== -1 ||
                    // Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                    (ctrlKey === true && $.inArray(e.keyCode, [65, 67, 86, 88]) !== -1)
                ) {
                    return;
                }
                if (
                    // numbers,
                    ((e.keyCode >= 48 && e.keyCode <= 57) && !e.shiftKey) ||
                    // numpad,
                    (e.keyCode >= 96 && e.keyCode <= 105) ||
                    // tablets numpad
                    (e.keyCode == 229)
                ) {
                    if (maxLength && $(this).val().length >= maxLength) {
                        e.preventDefault();
                    }
                    return;
                }
                e.preventDefault();
            });

            $element.focusout(function () {
                ko.bindingHandlers.numberInput.format($element, $element.val());
            });

            ko.bindingHandlers.textInput.init.apply(null, arguments);
            ko.bindingHandlers.numberInput.format($element, $element.val());
        },

        format: function ($element, value) {
            var maxLength = $element.attr('maxlength');
            if (maxLength && value.length > maxLength) {
                value = value.substr(0, maxLength);
            }
            value = value.replace(/[^0-9]/g, '');
            $element.val(value);
        }
    };

    ko.bindingHandlers.alphanumericInput = {
        init: function (element, valueAccessor) {
            var $element = $(element);
            $element.keydown(function (e) {
                if (
                    // Allow: backspace, delete, tab, escape, enter, end,  home, left, right, F5,
                    $.inArray(e.keyCode, [46, 8, 9, 27, 13, 35, 36, 37, 39, 116]) !== -1 ||
                    // Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                    (e.ctrlKey === true && $.inArray(e.keyCode, [65, 67, 86, 88]) !== -1)
                ) {
                    return;
                }

                if (/^[0-9a-zA-Z]+$/g.test(e.key)) {
                    return;
                }
                e.preventDefault();
            });

            $element.focusout(function () {
                ko.bindingHandlers.alphanumericInput.format($element, $element.val());
            });

            ko.bindingHandlers.textInput.init.apply(null, arguments);
            ko.bindingHandlers.alphanumericInput.format($element, $element.val());
        },

        format: function ($element, value) {
            var maxLength = $element.attr('maxlength');
            if (maxLength && value.length > maxLength) {
                value = value.substr(0, maxLength);
            }
            //value = value.replace(/^[0-9a-zA-Z]+$/g, '');
            $element.val(value);
        }
    }

    ko.bindingHandlers.alphanumericUnderscoreInput = {
        init: function (element, valueAccessor) {
            var $element = $(element);
            $element.keydown(function (e) {
                if (
                    // Allow: backspace, delete, tab, escape, enter, end,  home, left, right, F5,
                    $.inArray(e.keyCode, [46, 8, 9, 27, 13, 35, 36, 37, 39, 116]) !== -1 ||
                    // Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                    (e.ctrlKey === true && $.inArray(e.keyCode, [65, 67, 86, 88]) !== -1)
                ) {
                    return;
                }

                if (/^[0-9a-zA-Z_]+$/g.test(e.key)) {
                    return;
                }
                e.preventDefault();
            });

            $element.focusout(function () {
                ko.bindingHandlers.alphanumericInput.format($element, $element.val());
            });

            ko.bindingHandlers.textInput.init.apply(null, arguments);
            ko.bindingHandlers.alphanumericInput.format($element, $element.val());
        },

        format: function ($element, value) {
            var maxLength = $element.attr('maxlength');
            if (maxLength && value.length > maxLength) {
                value = value.substr(0, maxLength);
            }
            //value = value.replace(/^[0-9a-zA-Z]+$/g, '');
            $element.val(value);
        }
    }

    ko.bindingHandlers.numberInputWithValueProcessing = {
        // used when we need to use preventDefault for all devices (iPad bug, WCP-1143)
        init: function (element) {
            var $element = $(element);
            $element.on('input', function (e) {
                var value = $(this).val();
                var fixedValue = value.replace(/[^0-9]/g, '');
                var keyCode = $(this).data('key_code');
                var prevValue = $(this).data('prev_value');
                var maxLength = $(this).attr('maxlength');
                var phoneDebugBox = $('#phone_debug_box');
                if (phoneDebugBox.length) {
                    phoneDebugBox.html(value + '/' + prevValue + '_' + keyCode + '_' + value.length + '/' + maxLength);
                }

                // e-character fix and maxlength check
                if ((keyCode === 69) || (maxLength && value.length > maxLength)) {
                    $(this).val(prevValue);
                    return;
                }
                if (fixedValue !== value) {
                    $(this).val(fixedValue);
                }
                $(this).data('prev_value', fixedValue);
            });

            $element.on('keydown', function (e) {
                $(this).data('key_code', e.keyCode);
            });

            $element.focusout(function () {
                ko.bindingHandlers.numberInput.format($element, $element.val());
            });

            ko.bindingHandlers.textInput.init.apply(null, arguments);
            ko.bindingHandlers.numberInput.format($element, $element.val());
        }
    };

    ko.bindingHandlers.currencyInput = {
        init: function (element, valueAccessor) {
            var $element = $(element);
            var allowNegative = $element.attr("allowNegative") == "true";
            $element.keydown(function (e) {
                var inputType = $(this).attr('type').toLowerCase();

                // NOTE: removed this condition because of browsers allow dot and comma as separators.
                // if (inputType !== 'number') {
                var value = (ko.unwrap(valueAccessor()) || '').toString();
                //minus
                if (allowNegative && (e.keyCode === 189 || e.keyCode === 173 || e.keyCode === 109)) {
                    if (value.indexOf('-') === -1)
                        return;
                }

                // user pressed dot when all text is selected
                // if (e.keyCode === 190 && document.getSelection().toString() === value) {
                //     return;
                // }
                var jsInput = $(this).get(0);
                if ((e.keyCode === 190 || e.keyCode === 110) &&
                    typeof (jsInput.selectionStart) === 'number' &&
                    jsInput.selectionStart == 0 &&
                    jsInput.selectionEnd == jsInput.value.length) {
                    return;
                }

                var noPoint = value.indexOf('.') === -1;
                if (
                    // Allow: backspace, delete, tab, escape, enter, end,  home, left, right, F5,
                    $.inArray(e.keyCode, [46, 8, 9, 27, 13, 35, 36, 37, 39, 116]) !== -1 ||
                    // only one point for string,
                    ($.inArray(e.keyCode, [110, 190]) !== -1 && noPoint) ||
                    // Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                    (e.ctrlKey === true && $.inArray(e.keyCode, [65, 67, 86, 88]) !== -1) ||
                    // numbers,
                    ((e.keyCode >= 48 && e.keyCode <= 57) && !e.shiftKey) ||
                    // numpad.
                    (e.keyCode >= 96 && e.keyCode <= 105)
                ) {
                    return;
                }
                e.preventDefault();
                // }
            });

            $element.focus(function () {
                setTimeout(function () {
                    let nativeElement = $element.get(0);

                    // WCP-4892 fix
                    if (typeof nativeElement.select === "function") {
                        nativeElement.select();
                    } else {
                        let textLen = $(element).val().length;
                        let realType = nativeElement.type;

                        if (["text", "search", "url", "tel", "password"].includes(realType)) {
                            nativeElement.setSelectionRange(0, textLen);
                        } else {
                            nativeElement.type = "text";
                            nativeElement.setSelectionRange(0, textLen);
                            nativeElement.type = realType;
                        }
                    }
                }, 0);
            });

            $element.blur(function () {
                ko.bindingHandlers.currencyInput.format($element, $element.val());
            });

            ko.bindingHandlers.textInput.init.apply(null, arguments);
            ko.bindingHandlers.currencyInput.format($element, $element.val());
        },

        format: function ($element, value) {
            var formattedValue = '';
            if ($.type(value) === "string") {
                if (value.length > 0) {
                    value = parseFloat(value);
                    if (isNaN(value))
                        value = 0;
                    formattedValue = value.toFixed(2);
                }
            } else if ($.isNumeric(value)) {
                formattedValue = value.toFixed(2);
            } else {
                return;
            }

            $element.val(formattedValue);
        }
    };

    ko.bindingHandlers.initTooltipster = {
        init: function (element, valueAccessor) {
            if (valueAccessor().skipInitialization)
                return;

            var $t = $(element);
            var preventDuplicate = valueAccessor().preventDuplicate;
            if (preventDuplicate && $t.data('tooltipstered') === true) {
                return;
            }

            var isTouchDevice = ('ontouchend' in window);
            $t.find('.b-tooltip').attr('role', 'tooltip');

            var tooltipBtn = $t.find('.js-tooltip-btn');
            tooltipBtn.attr('aria-expanded', 'false');
            tooltipBtn.click(function (e) {
                e.stopPropagation();
                if (isTouchDevice) {
                    return;
                }

                if ($(this).attr('aria-expanded') === 'false') {
                    $t.tooltipster('show');
                } else {
                    $t.tooltipster('hide');
                }
            });
            tooltipBtn.keydown(function(e) {
                e.stopPropagation();
                if (e.keyCode === 27) {
                    $t.tooltipster('hide');
                }
            });
            tooltipBtn.keyup(function(e) {
                if (e.keyCode === 27) {
                    e.stopPropagation();
                }
            });
            tooltipBtn.blur(function(e) {
                $t.tooltipster('hide');
            });

            tooltipBtn.focus(function(e) {
                $t.tooltipster('show');
            });

            var tooltipContent = valueAccessor().tooltipContent;
            if (tooltipContent) {
                const parser = document.createElement('textarea');
                parser.innerHTML = tooltipContent;
                $t.find(".b-tooltip-content").html(tooltipContent);
            }

            let tooltipTitle = valueAccessor().tooltipTitle;
            if (tooltipTitle) {
                $t.find(".b-tooltip-title").text(tooltipTitle);
            }

            var contentSelector = valueAccessor().contentSelector;
            if (contentSelector) {
                $t.attr('title', $t.find(contentSelector).html());
            } else {
                $t.attr('title', $t.html());
            }
           
            var activeIfEnabledSelector = valueAccessor().activeIfEnabledSelector;
            var activeIfDisabledSelector = valueAccessor().activeIfDisabledSelector;

            $t.tooltipster({
                //trigger: 'click',
                //autoClose: false,
                theme: 'tooltip-anthem',
                contentAsHTML: true,
                contentCloning: false,
                speed: 100,
                interactive: true,
                interactiveTolerance: 150,
                // hideOnClick: true,
                functionBefore: function (origin, continueTooltip) {
                    origin.find('.js-tooltip-btn').attr('aria-expanded', 'true');
                    if (!activeIfEnabledSelector && !activeIfDisabledSelector) {
                        continueTooltip();
                    } else {
                        if (activeIfEnabledSelector) {
                            if ($t.find(activeIfEnabledSelector).is(":enabled")) {
                                continueTooltip();
                            }
                        } else if (activeIfDisabledSelector) {
                            if ($t.find(activeIfDisabledSelector).is(":disabled")) {
                                continueTooltip();
                            }
                        }
                    }
                },
                functionAfter: function (origin) {
                    origin.find('.js-tooltip-btn').attr('aria-expanded', 'false');
                },
                functionReady: function (origin, tooltip) {
                    //#216128 - Remove title attribute to avoid default tooltip with code 
                    if ($(origin).attr('title') !== 'undefined')
                        $(origin).removeAttr('title');

                    tooltip.click(function () {
                        $(origin).tooltipster('hide');
                    });
                }                
            });

            setTimeout(function() {
                $t.removeAttr('title');
            }, 200);

            if (preventDuplicate) {
                $t.data('tooltipstered', true);
            }
        }
    };

    ko.bindingHandlers.tooltipster = {
        init: function (element, valueAccessor) {
            var options = $.extend({ theme: 'tooltip-anthem', contentAsHTML: true }, valueAccessor());
            $(element).tooltipster(options);
        }
    };

    ko.bindingHandlers.initTooltipsterBase = {
        init: function (el, valueAccessor) {
            $(el).tooltipster({ theme: 'tooltip-anthem', contentAsHTML: true });
        }
    };

    ko.bindingHandlers.accountBalanceTotalSpans = {
        update: function (element, valueAccessor) {
            var val = ko.unwrap(valueAccessor());
            var balance = 0;

            if (val.accountIntervalType()) {
                if (val.AccountPlanYear == $.cdh.enums.planYear.future) {
                    balance = '$--.--'
                }
                else {
                    balance = val.currentSpendingLimit;
                }
            }
            else if (val.AccountType != $.cdh.enums.accountType.parking && val.AccountType != $.cdh.enums.accountType.transit) {
                balance = val.TotalBalance;
            }
            else {
                    balance = val.AvailableBalance;
                }


            var newValueAccessor = function () {
                if (val.accountIntervalType()) {
                    return {
                        'SpendingLimitField': val.FieldsAliases.SpendingLimit,
                        balance,
                        isInterval: true,
                        'AccountPlanYear': val.AccountPlanYear
                    }
                }
                return balance; 
            };

            ko.bindingHandlers.currencySpans.update(element, newValueAccessor);
        }
    };

    ko.bindingHandlers.prependText = {
        update: function (element, valueAccessor) {
            var val = ko.unwrap(valueAccessor());
            var $el = $(element);
            var html = $el.html();
            $el.empty().append(val, html);
        }
    };

    // WCP-2949 test
    // ko.bindingHandlers.FormEnterKeySubmit = {
    //     update: function (element, valueAccessor) {
    //         var body = $('body');
    //         var $form = $(element);
    //         $(window).keydown(function (e) {
    //             if (e.keyCode == 13 && !body.hasClass('mfp-wait-alert-popup')) {
    //                 var $submit = $form.find('button[type=submit]');
    //                 if ($submit.is(":visible") && $submit.is(":enabled")) {
    //                     $submit.trigger('click');
    //                     return false;
    //                 }
    //             }
    //         });
    //     }
    // };
    // / WCP-2949 test

    ko.bindingHandlers.FormEnterKeyCustom = {
        update: function (element, valueAccessor) {
            var body = $('body');
            $(window).keydown(function (e) {
                if (e.keyCode == 13 && !body.hasClass('mfp-wait-alert-popup')) {
                    var resetFocus = valueAccessor().resetFocus;
                    var ifFocusFunc = valueAccessor().ifFocus;
                    var ifNoFocusFunc = valueAccessor().ifNoFocus;

                    if ($(":focus").length > 0 && $.isFunction(ifFocusFunc)) {
                        ifFocusFunc();
                    } else if ($.isFunction(ifNoFocusFunc)) {
                        ifNoFocusFunc();
                    }

                    if (resetFocus) {
                        $(":focus").blur();
                    }

                    return false;
                }
            });
        }
    };

    ko.bindingHandlers.communicationsSummaryStickyTable = {
        update: function (element, valueAccessor) {
            var $tbl = $(element);
            if ($tbl.length) {
                var $win = $(window);
                $win.scroll(function () {
                    if (($win.scrollTop() > $tbl.offset().top) && ($win.scrollTop() < ($tbl.offset().top + $tbl.outerHeight() - 109))) {
                        $tbl.addClass('pfixed');
                    } else {
                        $tbl.removeClass('pfixed');
                    }
                });
            }
        }
    };

    ko.bindingHandlers.optionsEnum = {
        init: ko.bindingHandlers.options.init,
        update: function (element, valueAccessor, allBindings) {
            var enumName = ko.unwrap(valueAccessor());
            var enumValues = ko.bindingHandlers['enum' + enumName].enumText;
            var extendOptions = allBindings().extendOptions || {};
            let keys = allBindings().keys;

            enumValues = $.extend({}, enumValues, extendOptions);
            let list = $.map(enumValues, function (value, key) { return { key: key, value: $.cdh.languageConstant.getConstant(`Enum.${enumName}.${value}`) }; });

            if (keys) {
                list = list.filter(function (item) {
                    return keys.includes(parseInt(item.key));
                });
            }

            list.sort(function (a, b) { return a.key - b.key });

            function getList() {
                return list;
            }

            var settings = {
                optionsText: 'value',
                optionsValue: 'key'
            }

            function wrapBindings() {
                return allBindings();
            }

            wrapBindings['has'] = function (key) {
                if (key in settings) return true;
                return allBindings.has(key);
            }
            wrapBindings['get'] = function (key) {
                if (key in settings) return settings[key];
                return allBindings.get(key);
            }

            ko.bindingHandlers.options.update(element, getList, wrapBindings);
        }
    };

    ko.bindingHandlers.ifRequired = {
        init: function (element, valueAccessor) {
            var observable = valueAccessor();
            if (!ko.isObservable(observable) || !ko.isObservable(observable.rules)) {
                throw new Error("ifRequired binding applies only to observable with validation");
            }
        },
        update: function (element, valueAccessor) {
            var observable = valueAccessor();
            var rule = ko.utils.arrayFirst(observable.rules(), function (item) {
                return item.rule && item.rule === "required";
            });
            ko.bindingHandlers.visible.update(element, function () {
                return rule.params === true && (rule.condition ? rule.condition() : true);
            });
        }
    };

    ko.bindingHandlers.requiredAttr = {
        init: function (element, valueAccessor) {
            var observable = valueAccessor();
            if (!ko.isObservable(observable) || !ko.isObservable(observable.rules)) {
                throw new Error("ifRequired binding applies only to observable with validation");
            }
        },
        update: function (element, valueAccessor) {
            var observable = valueAccessor();
            var rule = ko.utils.arrayFirst(observable.rules(), function (item) {
                return item.rule && item.rule === "required";
            });
            if (rule.params === true && (rule.condition ? rule.condition() : true)) {
                element.setAttribute('required', 'required');
            } else if (element.hasAttribute('required')) {
                element.removeAttribute('required', 'required');
            }
        }
    };

    ko.bindingHandlers.slideIn = {
        init: function (element, valueAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            $(element).toggle(value);
        },
        update: function (element, valueAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            value ? $(element).slideDown() : $(element).slideUp();
        }
    };

    ko.bindingHandlers.htmlBound = {
        init: function () {
            return { controlsDescendantBindings: true };
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            ko.utils.setHtml(element, valueAccessor());
            ko.applyBindingsToDescendants(bindingContext, element);
        }
    };

    ko.bindingHandlers.autocompleteField = {
        init: function (element, valueAccessor) {
            var settings = valueAccessor();
            $(element).autocompleteField(settings);
        }
    };

    ko.bindingHandlers.cardNumber = {
        init: function (element, valueAccessor) {
            let number = valueAccessor();
            let $element = $(element);

            $element.on('input', function () {
                let formattedNumber = $.payform.formatCardNumber($element.val());
                $element.val(formattedNumber);

                if (ko.isObservable(number)) {
                    number($element.val().replace(/\s/g, ''));
                }
            });
        },
        update: function (element, valueAccessor) {
            let number = valueAccessor();

            if (ko.isObservable(number)) {
                let $element = $(element);
                let numberValue = number();
                let normalizedValue = $element.val().replace(/\s/g, '');
                if (numberValue !== normalizedValue) {
                    let formattedNumber = $.payform.formatCardNumber(numberValue);
                    $element.val(formattedNumber);
                }
            }
        }
    };
    ko.validation.makeBindingHandlerValidatable('cardNumber');

    ko.bindingHandlers.visibleIfSet = {
        update: function (element, valueAccessor) {
            let value = ko.utils.unwrapObservable(valueAccessor());
            let isSet = value !== undefined && value !== null && value !== '';
            let isCurrentlyVisible = !(element.style.display == "none");
            if (isSet && !isCurrentlyVisible)
                element.style.display = "";
            else if ((!isSet) && isCurrentlyVisible)
                element.style.display = "none";
        }
    };

    ko.bindingHandlers.dynamicTag = {
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            let tagName = ko.utils.unwrapObservable(valueAccessor());
            if (tagName) {
                let tagHtml = `<${tagName}></${tagName}>`;
                ko.utils.setHtml(element, tagHtml);
                ko.applyBindingsToDescendants(bindingContext, element);
            }
        }
    };

    ko.bindingHandlers.dropdownMenu = {
        init: function (element, valueAccessor) {
            var options = valueAccessor();
            $.cdh.helper.initMenuAccesibility(element, options);
            $.cdh.helper.initMenuNavigation(element, options);
        }
    }



    ko.bindingHandlers.dropdownFilterGroup = {
        update: function (element, valueAccessor) {
            const openedClassName = 'data-filter__item--opened';
            const openedToLeftClassName = 'data-filter__item--opened--left';
            const itemBtnClassName = 'data-filter__item-text--btn';
            const itemBtnTextClassName = 'data-filter__item-text--btn-text';

            function getDropdownParent(elem) {
                return elem.closest('div.data-filter__item');
            }
            function isDropdownOpened(elem) {
                return getDropdownParent(elem).hasClass(openedClassName);
            }
            function showDropdown(elem) {
                elem.attr('aria-expanded', 'true');
                let filterItem = getDropdownParent(elem);
                filterItem.addClass(openedClassName);

                const $menuItems = filterItem.find('[role="menuitem"], [role="menuitemradio"]');
                if ($menuItems.length > 0) {
                    $menuItems.attr('tabindex', -1);
                    $menuItems.first().attr('tabindex', 0);
                }

                fixDropdownPosition(filterItem);
            }
            function hideDropdown(elem) {
                getDropdownParent(elem)
                    .removeClass(openedClassName)
                    .removeClass(openedToLeftClassName)
                    .find('.' + itemBtnClassName)
                    .removeAttr('aria-expanded');
            }
            function hideAllDropdowns() {
                $('div.data-filter__item--opened')
                    .removeClass(openedClassName)
                    .removeClass(openedToLeftClassName)
                    .find('.' + itemBtnClassName)
                    .removeAttr('aria-expanded');

            }
            function fixDropdownPosition(filterItem) {
                let dropdown = filterItem.find('div.data-filter__dropdown');
                if (!dropdown.length) {
                    return;
                }

                dropdown = dropdown.get(0);
                dropdown.style.removeProperty('right');
                let mainElemRect = $('#main-content').get(0).getBoundingClientRect();
                let dropdownRect = dropdown.getBoundingClientRect();
                if (dropdownRect.right > mainElemRect.right) {
                    if ((dropdownRect.right - mainElemRect.right) < (dropdownRect.left - mainElemRect.left)) {
                        filterItem.addClass(openedToLeftClassName);
                        dropdownRect = dropdown.getBoundingClientRect();
                        if (dropdownRect.left < mainElemRect.left) {
                            let diff = mainElemRect.left - dropdownRect.left + 5;
                            dropdown.style.right = '-' + diff + 'px';
                        }
                    }
                }
            }

            let filter = $(element);
            const uuid = guid();
            filter.find('.' + itemBtnClassName).each(function (idx) {
                const uId = `${uuid}__${idx}`;
                const buttonId = `button__${uId}`;
                const controlId = `dropdown__${uId}`;

                const filterItem = getDropdownParent($(this));
                const dropdown = filterItem.find('div.data-filter__dropdown');

                $(this).attr({
                    id: buttonId,
                    'aria-haspopup': 'true',
                    'aria-controls': controlId,
                });

                dropdown.attr({
                    'id': controlId,
                    'aria-labelledby': buttonId,
                });

                $(this).on('click', function () {
                    let isOpened = isDropdownOpened($(this));
                    hideAllDropdowns();
                    if (isOpened) {
                        hideDropdown($(this));
                    } else {
                        showDropdown($(this));
                    }
                });
                $(this).on('keydown', function (e) {
                    if (e.keyCode === 27) {
                        hideDropdown($(this));
                    }
                });
            });
            filter.find('div.data-filter__dropdown').each(function () {
                const $dropdown = $(this);
                const $menu = $dropdown.find('[role="menu"]');
                const $filterItem = getDropdownParent($dropdown);
                $dropdown.on('click', function (e) {
                    e.stopPropagation();
                });
                // $dropdown.find('.data-filter__dropdown-btn'.on('blur', function (e) {
                // Note: hidden inputs produce focus outside of dropdown on click
                // As a workaround we use only buttons and whole container for blur check
                //$filterItem.on('blur', 'button', function (e) {
                //    if (e.relatedTarget && $dropdown[0].contains(e.relatedTarget)) {
                //        return;
                //    }
                //    hideDropdown($(this));
                //});

                $menu.on('exit', function(){
                    hideDropdown($dropdown);
                });

            });

            $(window).on('click', function (e) {
                if ($(e.target).hasClass(itemBtnClassName) || $(e.target).hasClass(itemBtnTextClassName)) {
                    return;
                }
                hideAllDropdowns();
            });
        }
    };

    ko.bindingHandlers.translationHandler = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            const key = ko.unwrap(typeof (valueAccessor) != 'string' ? valueAccessor() : valueAccessor);     
            const options = allBindingsAccessor != undefined ? allBindingsAccessor().translationOptions : '';           
            const translatedText = $.cdh.languageConstant.getConstant(key, options);
            ko.bindingHandlers.html.update(element, () => translatedText);
        },
        update: function (element, valueAccessor, allBindingsAccessor) {
            const key = ko.unwrap(typeof (valueAccessor) != 'string' ? valueAccessor() : valueAccessor);
            const options = allBindingsAccessor != undefined? allBindingsAccessor().translationOptions:'';  
            const translation = $.cdh.languageConstant.getConstant(key, options);       
            ko.bindingHandlers.html.update(element, () => translation);
        },
    };

    ko.bindingHandlers.getTranslationInTargetLangauge = {
        //TODO: Redesign the handler to consider all cases like incoming langauge in supported langauges and support for different namespaces, currently using deafult namespace 
        init: function (element, valueAccessor, allBindingsAccessor) {
            const key = ko.unwrap(typeof (valueAccessor) != 'string' ? valueAccessor() : valueAccessor);
            const options = allBindingsAccessor != undefined ? allBindingsAccessor().translationOptions : '';
            const targetLang = (allBindingsAccessor != undefined || (typeof (allBindingsAccessor().targetlanguage) == 'string')) ? allBindingsAccessor().targetlanguage : 'en';
            const translation = $.cdh.languageConstant.getResource(key, targetLang, options);
            ko.bindingHandlers.html.update(element, () => translation);
        },
        update: function (element, valueAccessor, allBindingsAccessor) {
            const key = ko.unwrap(typeof (valueAccessor) != 'string' ? valueAccessor() : valueAccessor);
            const options = allBindingsAccessor != undefined ? allBindingsAccessor().translationOptions : '';
            const targetLang = (allBindingsAccessor != undefined || (typeof (allBindingsAccessor().targetlanguage) != 'string')) ? allBindingsAccessor().targetlanguage : 'en';
            const translation = $.cdh.languageConstant.getResource(key, targetLang, options);
            ko.bindingHandlers.html.update(element, () => translation);
        }
    }
    function guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

}(jQuery));
